import React, { useState, useEffect } from "react";
import { getEmailBkup } from '../utils/propertyMapUtil';

const ContactForm = ({
  toEmail,
  slug = null,
  arrivalInfo = null,
  sendMarketingEmail = false,
  appendToBody = "",
  uid = null,
  sessionId = null,
}) => {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");
  const [notification, setNotification] = useState("");
  const [mailpass, setMailpass] = useState("");
  const [mailuser, setMailuser] = useState("");
  const [sending, setSending] = useState(false);
  const [hasBeenSent, setHasBeenSent] = useState(false);
  const [agreeToTextMessages, setAgreeToTextMessages] = useState(false);

  useEffect(() => {
    let mailpass = sessionStorage.getItem("mailpass");
    let mailuser = sessionStorage.getItem("mailuser");
    if (mailpass && mailpass.length > 0 && mailuser && mailuser.length > 0) {
      setMailpass(mailpass);
      setMailuser(mailuser);
    } else {
      getAuth(
        "https://mailut.mcklab.com/?action=login&username=orangepup&password=" +
          createPass(),
      );
    }
  }, []);

  const handleAgreeToTextMessages = (e) => {
    setAgreeToTextMessages(e.target.checked);
  };

  const handleFname = (e) => {
    setFname(e.target.value);
  };
  const handleLname = (e) => {
    setLname(e.target.value);
  };

  const handleEmail = (e) => {
    const inputValue = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // regular expression to match email format
    const isValidEmail = emailRegex.test(inputValue);

    if (isValidEmail) {
      setEmail(inputValue);
    } else {
      let formattedEmail = inputValue.replace(/\s/g, ""); // remove any whitespace
      setEmail(formattedEmail);
    }
  };

  const handlePhone = (e) => {
    const inputValue = e.target.value.replace(/\D/g, "").substring(0, 10); // Remove non-numeric characters and limit to 10 digits
    const areaCode = inputValue.substring(0, 3);
    const middle = inputValue.substring(3, 6);
    const last = inputValue.substring(6, 10);

    let formattedPhone = "";
    if (inputValue.length > 6) {
      formattedPhone = `(${areaCode}) ${middle}-${last}`;
    } else if (inputValue.length > 3) {
      formattedPhone = `(${areaCode}) ${middle}`;
    } else if (inputValue.length > 0) {
      formattedPhone = `(${areaCode}`;
    }

    setPhone(formattedPhone);
  };

  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const handleSendMail = () => {
    setSending(true);
    //send message
    if (
      fname.trim().length > 0 &&
      lname.trim().length > 0 &&
      email.trim().length > 0 &&
      phone.trim().length > 0 &&
      message.trim().length > 0 &&
      agreeToTextMessages
    ) {
      let sendData = {
        loggedin_pass: mailpass,
        loggedin_user: mailuser,
        action: "mail",
        to: toEmail,
        cc: getEmailBkup(slug),
        name: fname.trim() + " " + lname.trim(),
        subject:
          "McKinley.com Contact Form Message from " +
          fname.trim() +
          " " +
          lname.trim(),
        body: `Full Name: ${fname.trim()} ${lname.trim()} \n
                        Email: ${email.trim()} \n
                        Phone: ${phone.trim().replace(/\D/g, "")} \n
                        Notes: ${appendToBody ? message.trim() + " \n" + appendToBody : message.trim()}\n
                        Session ID: ${sessionId}`,
      };

      let endpoint = "https://mailut.mcklab.com";

      sendMail(endpoint, sendData);
    } else {
      if (!agreeToTextMessages) {
        setResponse("Must agree to recieve text messages");
      } else {
        setResponse("All fields are required");
      }
      setNotification("is-warning");
      setSending(false);
    }
  };

  const createPass = () => {
    let date = new Date();
    let dateString = date.toISOString().slice(0, 10);
    let pass = "froglegs";
    let encodedString = btoa(dateString + pass);
    return encodedString;
  };

  const sendMail = (url, data) => {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "tenOrangePups22",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        if (res.message_type == "success" || res.errorCode == 200) {
          //we sent the email message
          setResponse("Message sent successfully");
          setNotification("is-success");
        } else {
          setResponse("Sorry, we were not able to send a message at this time");
          setNotification("is-danger");
        }
        setSending(false);
        setHasBeenSent(true);
      });
  };

  const getAuth = (url) => {
    fetch(url)
      .then((response) => response.json())
      .then((res) => {
        if (res.message_type == "success") {
          setMailpass(res.loggedin_pass);
          setMailuser(res.loggedin_user);
          // Session storage not local storage
          sessionStorage.setItem("mailpass", res.loggedin_pass);
          sessionStorage.setItem("mailuser", res.loggedin_user);
        } else {
          setResponse(
            "We were not able to authorize this form to send emails. Please try again later",
          );
          setNotification("is-warning");
        }
      });
  };

  return (
    <div id="contact_form ">
      {response && (
        <div className={notification + " notification"}>{response}</div>
      )}
      <br />
      <div className="field">
        <label className="label">First Name*</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="e.g Alex "
            onChange={handleFname}
            value={fname}
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Last Name*</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="e.g Smith"
            onChange={handleLname}
            value={lname}
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Email*</label>
        <div className="control">
          <input
            className="input"
            type="email"
            placeholder="e.g. alexsmith@gmail.com"
            onChange={handleEmail}
            value={email}
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Phone*</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="e.g 555-555-5555"
            onChange={handlePhone}
            value={phone}
          />
        </div>
      </div>
      <div className="field">
        <label className="label">Message*</label>
        <div className="control">
          <textarea
            className="textarea"
            onChange={handleMessage}
            placeholder="e.g. How many bedrooms, budget, desired move-in date, etc."
          ></textarea>
        </div>
      </div>
      <div className="field">
        <div className="control">
          <label className="checkbox">
            <input
              type="checkbox"
              onChange={handleAgreeToTextMessages}
              checked={agreeToTextMessages}
            />
            &nbsp;By checking this box you agree to our Privacy Policy <br />
            and to receive text messages from McKinley. <br />
            Reply STOP to opt out
          </label>
        </div>
      </div>

      <div className="field">
        {!sending && !hasBeenSent && (
          <button
            className={uid ? `${uid} button is-link` : "button is-link"}
            onClick={handleSendMail}
            disabled={!agreeToTextMessages}
          >
            Submit
          </button>
        )}
        {sending && <p>Sending...</p>}
        {hasBeenSent && <p>Thank you!</p>}
      </div>

      <br />
    </div>
  );
};

export default ContactForm;
